import React from 'react';
import parser from 'html-react-parser'

export default class Description extends React.Component<{ children: any, className?: any }, { [label: string]: any }> {

    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        }
        this.collapseToggle = this.collapseToggle.bind(this);
    }

    public collapseToggle(e?: any) {
        e.preventDefault();
        this.setState({ collapsed: !this.state.collapsed });
    }

    public render() {

        const newText = this.props.children.split('\n\n').map((para, x) => {

            return <p key={x} style={{ fontSize: '15px' }}>
                {
                    para.split('\n').map((line, index) => {
                        if (line.length !== 0) {
                            const regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
                           
                            const htmlText = line.split(' ').map((word: string) => {
                                if (regexp.test(word)) {
                                    if (word.includes('https') || word.includes('http')) {
                                        return `<a href="${word}" target="_blank">${word}</a>`
                                    } else {
                                        return `<a href="https://${word}" target="_blank">${word}</a>`
                                    }
                                } else {
                                    return word
                                }
                            }).join(' ')

                            return <div key={index}>{parser(htmlText)}</div>
                        }
                    })
                }
            </p>

        });

        const { children } = this.props;
        const { collapsed } = this.state;

        if (!children) {
            return null;
        }

        const length = 250;

        return (
            <div className={"gray-text text-left " + this.props.className ? this.props.className : ''}>
                {children.length > length || newText.length >= 5 ? (
                    <React.Fragment>
                        <div>{collapsed ? <p style={{ wordWrap: 'break-word', fontSize: '15px' }}>{children.substr(0, length - 1) + '...'}</p> : newText}</div>
                        <div
                            onClick={this.collapseToggle}
                            style={{ cursor: 'pointer' }}
                        >
                            {!collapsed ? "Show Less" : "Show More"}
                        </div>
                    </React.Fragment>
                ) : (
                        newText
                    )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/Description.tsx